module.exports = __webpack_public_path__ + "static/comercial-trash-service-51eda6a16b402b8d3e2d57a788e5dbca.jpg";